/* ============================================
   SELLERDASHBOARDOVERVIEW.JSX
   📁 File location: src/pages/sellers/SellerDashboardOverview.jsx
   ✅ Same pattern as SellerAnalytics.jsx
      (SellerMasterLayout wrap, dropdown state pattern,
      var(--xxx, fallback) css vars)
   ============================================ */

import React, { useContext, useEffect, useState } from 'react';
import {
  Home,
  ShieldCheck,
  CalendarCheck,
  CalendarX,
  ChevronDown,
  CheckCircle2,
  ArrowUp,
  ArrowDown
} from 'lucide-react';
import {
  LineChart, Line,
  BarChart, Bar,
  PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import '../../../assets/css/sellers/dashboard/selleranalytics/analytics.css';
import SellerMasterLayout from 'layouts/SellerMasterLayout';
import axios from 'axios';
import AppContext from 'context/AppContext';

/* ---------------- Stat cards data ---------------- */

// const statCards = [
//   {
//     id: 'properties',
//     label: 'Properties',
//     value: '12',
//     // subLabel: 'Active Properties',
//     trend: '20%',
//     trendUp: true,
//     icon: <Home size={22} />,
//     color: 'stat-purple'
//   },
//   {
//     id: 'kyc',
//     label: 'KYC Requests',
//     value: '10',
//     split: [
//       { label: 'Accepted', value: 8, color: 'split-green' },
//       { label: 'Rejected', value: 2, color: 'split-red' }
//     ],
//     trend: '33%',
//     trendUp: true,
//     icon: <ShieldCheck size={22} />,
//     color: 'stat-green'
//   },
//   {
//     id: 'accepted-visits',
//     label: 'Accepted Visits',
//     value: '45',
//     trend: '25%',
//     trendUp: true,
//     icon: <CalendarCheck size={22} />,
//     color: 'stat-blue'
//   },
//   {
//     id: 'rejected-visits',
//     label: 'Rejected Visits',
//     value: '18',
//     trend: '10%',
//     trendUp: false,
//     icon: <CalendarX size={22} />,
//     color: 'stat-red'
//   }
// ];

// /* ---------------- Properties growth (line chart) ---------------- */
// const growthData = [
//   { date: 'May 05', properties: 4 },
//   { date: 'May 08', properties: 4 },
//   { date: 'May 11', properties: 5 },
//   { date: 'May 14', properties: 5 },
//   { date: 'May 17', properties: 7 },
//   { date: 'May 20', properties: 6 },
//   { date: 'May 23', properties: 9 },
//   { date: 'May 26', properties: 9 },
//   { date: 'May 29', properties: 10 },
//   { date: 'Jun 01', properties: 11 },
//   { date: 'Jun 04', properties: 12 }
// ];

// /* ---------------- Visit requests status (bar chart) ---------------- */
// const visitRequestsData = [
//   { date: 'May 05', accepted: 30, rejected: 10 },
//   { date: 'May 11', accepted: 25, rejected: 8 },
//   { date: 'May 17', accepted: 35, rejected: 12 },
//   { date: 'May 23', accepted: 40, rejected: 20 },
//   { date: 'May 29', accepted: 38, rejected: 15 },
//   { date: 'Jun 04', accepted: 45, rejected: 18 }
// ];

/* ---------------- KYC requests status (donut chart) ---------------- */
// const kycData = [
//   { name: 'Accepted', value: 8, color: '#48bb78' },
//   { name: 'Rejected', value: 2, color: '#fc8181' }
// ];

const SellerAnalytics = () => {
  const [propertiesPeriod, setPropertiesPeriod] = useState('Last 30 Days');
  const [visitsPeriod, setVisitsPeriod]         = useState('Last 30 Days');
  const [kycPeriod, setKycPeriod]               = useState('Last 30 Days');

  const [propertiesDropdown, setPropertiesDropdown] = useState(false);
  const [visitsDropdown, setVisitsDropdown]         = useState(false);
  const [kycDropdown, setKycDropdown]               = useState(false);
  const { baseUrl,authToken } = useContext(AppContext);
  const seller = JSON.parse(localStorage.getItem("loggedInSeller"));

// ---------- Dashboard Cards ----------
const [totalProperties, setTotalProperties] = useState(0);
const [acceptedKyc, setAcceptedKyc] = useState(0);
const [rejectedKyc, setRejectedKyc] = useState(0);
const [acceptedVisits, setAcceptedVisits] = useState(0);
const [rejectedVisits, setRejectedVisits] = useState(0);
const [newThisMonth, setNewThisMonth] = useState(0);

const [propertyPercentage, setPropertyPercentage] = useState(0);
const [kycPercentage, setKycPercentage] = useState(0);
const [acceptedVisitPercentage, setAcceptedVisitPercentage] = useState(0);
const [rejectedVisitPercentage, setRejectedVisitPercentage] = useState(0);

// ---------- Charts ----------
const [growthData, setGrowthData] = useState([]);
const [visitRequestsData, setVisitRequestsData] = useState([]);
const [kycData, setKycData] = useState([]);

const statCards = [
{
    id:'properties',
    label:'Properties',
    value:totalProperties,
    trend:`${propertyPercentage}%`,
    trendUp:true,
    icon:<Home size={22}/>,
    color:'stat-purple'
},
{
    id:'kyc',
    label:'KYC Requests',
    value:acceptedKyc + rejectedKyc,
    split:[
        {
            label:'Accepted',
            value:acceptedKyc,
            color:'split-green'
        },
        {
            label:'Rejected',
            value:rejectedKyc,
            color:'split-red'
        }
    ],
    trend:`${kycPercentage}%`,
    trendUp:true,
    icon:<ShieldCheck size={22}/>,
    color:'stat-green'
},
{
    id:'accepted-visits',
    label:'Accepted Visits',
    value:acceptedVisits,
    trend:`${acceptedVisitPercentage}%`,
    trendUp:true,
    icon:<CalendarCheck size={22}/>,
    color:'stat-blue'
},
{
    id:'rejected-visits',
    label:'Rejected Visits',
    value:rejectedVisits,
    trend:`${rejectedVisitPercentage}%`,
    trendUp:false,
    icon:<CalendarX size={22}/>,
    color:'stat-red'
}
];

  const periods = ['Today', 'Last 7 Days', 'Last 30 Days', 'This Month', 'This Year'];

  const kycTotal = kycData.reduce((sum, item) => sum + item.value, 0);
const viewSellerDashboard = () => {
axios.get(`${baseUrl}/seller/analytics/dashboard`, {
    headers: {
        Authorization: `Bearer ${authToken}`
    },
    params: {
        exseller_id: seller.id
    }
})
//     axios.get(`${baseUrl}/seller/analytics/dashboard`,{
//     headers:{
//          Authorization:`Bearer ${authToken}`
// }})
   
    .then((response)=>{

        console.log(response.data);

        setTotalProperties(response.data.totalProperties);
        setAcceptedKyc(response.data.acceptedKyc);
        setRejectedKyc(response.data.rejectedKyc);
        setAcceptedVisits(response.data.acceptedVisits);
        setRejectedVisits(response.data.rejectedVisits);
        setNewThisMonth(response.data.newThisMonth);

        setPropertyPercentage(response.data.propertyPercentage);
        setKycPercentage(response.data.kycPercentage);
        setAcceptedVisitPercentage(response.data.acceptedVisitPercentage);
        setRejectedVisitPercentage(response.data.rejectedVisitPercentage);

    })
    .catch((error)=>{
        console.log(error);
    });

};

const viewPropertyGrowth = () => {

//     axios.get(`${baseUrl}/seller/analytics/propertyGrowth`,{
//     headers:{
//          Authorization:`Bearer ${authToken}`
// }})
axios.get(`${baseUrl}/seller/analytics/propertyGrowth`, {
    headers: {
        Authorization: `Bearer ${authToken}`
    },
    params: {
        exseller_id: seller.id
    }
})
    .then((response)=>{

        console.log(response.data);

        const data = response.data.propertyGrowth.map((item)=>({

            date:item.date,
            properties:item.total

        }));

        setGrowthData(data);

    })
    .catch((error)=>{
        console.log(error);
    });

};

const viewVisitRequests = () => {

//     axios.get(`${baseUrl}/seller/analytics/visitRequests`,{
//     headers:{
//          Authorization:`Bearer ${authToken}`
// }})
axios.get(`${baseUrl}/seller/analytics/visitRequests`, {
    headers: {
        Authorization: `Bearer ${authToken}`
    },
    params: {
        exseller_id: seller.id
    }
})
    .then((response)=>{

        console.log(response.data);

        const data = response.data.visitRequests.map((item)=>({
            date:item.date,
            accepted:item.accepted,
            rejected:item.rejected

        }));

        setVisitRequestsData(data);

    })
    .catch((error)=>{
        console.log(error);
    });

};

const viewKycStatus = () => {

//     axios.get(`${baseUrl}/seller/analytics/kycStatus`,{
//     headers:{
//          Authorization:`Bearer ${authToken}`
// }})
axios.get(`${baseUrl}/seller/analytics/kycStatus`, {
    headers: {
        Authorization: `Bearer ${authToken}`
    },
    params: {
        exseller_id: seller.id
    }
})
    .then((response)=>{

        console.log(response.data);

        const data = [

            {
                name:"Accepted",
                value:response.data.accepted,
                color:"#48bb78"
            },

            {
                name:"Rejected",
                value:response.data.rejected,
                color:"#fc8181"
            }

        ];

        setKycData(data);

    })
    .catch((error)=>{
        console.log(error);
    });

};

useEffect(()=>{

    viewSellerDashboard();
    viewPropertyGrowth();
    viewVisitRequests();
    viewKycStatus();

},[]);
  return (
    <SellerMasterLayout pageTitle="Dashboard">
      <div className="overview-wrapper">

        {/* ===================== STAT CARDS ===================== */}
        <div className="overview-stats-grid">
          {statCards.map((card) => (
            <div key={card.id} className={`overview-stat-card ${card.color}`}>
              <div className="overview-stat-top">
                <div className="overview-stat-icon">{card.icon}</div>
                <div className="overview-stat-text">
                  <p className="overview-stat-label Poppins-Medium">{card.label}</p>
                  <h3 className="overview-stat-value Baloo2-Bold">{card.value}</h3>
                  {card.subLabel && (
                    <p className="overview-stat-sublabel Poppins-Regular">{card.subLabel}</p>
                  )}
                </div>
              </div>

              {card.split && (
                <div className="overview-stat-split">
                  {card.split.map((s, idx) => (
                    <React.Fragment key={s.label}>
                      {idx > 0 && <span className="overview-split-divider" />}
                      <div className="overview-split-item">
                        <span className="overview-split-label Poppins-Regular">{s.label}</span>
                        <span className={`overview-split-value Baloo2-Bold ${s.color}`}>{s.value}</span>
                      </div>
                    </React.Fragment>
                  ))}
                </div>
              )}

              <div className={`overview-stat-trend Poppins-Medium ${card.trendUp ? 'trend-up' : 'trend-down'}`}>
                {card.trendUp ? <ArrowUp size={14} /> : <ArrowDown size={14} />}
                <span>{card.trend} <span className="trend-muted">vs last 30 days</span></span>
              </div>
            </div>
          ))}
        </div>

        {/* ===================== CHARTS ROW ===================== */}
        <div className="overview-charts-grid">

          {/* -------- My Properties Growth -------- */}
          <div className="overview-chart-card">
            <div className="overview-chart-header">
              <h4 className="Baloo2-Bold">My Properties Growth</h4>
              <div className="dropdown-container">
                <button
                  className={`overview-period-selector ${propertiesDropdown ? 'active' : ''}`}
                  onClick={() => setPropertiesDropdown(!propertiesDropdown)}
                >
                  <span className="Poppins-Medium">{propertiesPeriod}</span>
                  <ChevronDown size={14} className={`chevron ${propertiesDropdown ? 'rotate' : ''}`} />
                </button>
                {propertiesDropdown && (
                  <div className="dropdown-menu">
                    {periods.map((p) => (
                      <div
                        key={p}
                        className={`dropdown-item Poppins-Medium ${propertiesPeriod === p ? 'selected' : ''}`}
                        onClick={() => { setPropertiesPeriod(p); setPropertiesDropdown(false); }}
                      >
                        {p}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="overview-chart-body">
              <ResponsiveContainer width="100%" height={220}>
                <LineChart data={growthData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#eef0f4" vertical={false} />
                  <XAxis dataKey="date" stroke="#9a9a9a" tick={{ fontSize: 11, fontFamily: 'Poppins-Regular' }} axisLine={false} tickLine={false} />
                  <YAxis stroke="#9a9a9a" tick={{ fontSize: 11, fontFamily: 'Poppins-Regular' }} axisLine={false} tickLine={false} />
                  <Tooltip contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0', fontFamily: 'Poppins-Regular' }} />
                  <Line
                    type="monotone"
                    dataKey="properties"
                  stroke="#8000FF"
                   strokeWidth={2.5}
                   dot={{ r: 4, fill: '#8000FF', strokeWidth: 0 }}
                    activeDot={{ r: 6 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>

            <div className="overview-chart-footer">
              <div className="overview-footer-item">
                <span className="overview-footer-label Poppins-Regular">Total Properties</span>
                <span className="overview-footer-value Baloo2-Bold">{totalProperties}</span>
              </div>
              <div className="overview-footer-item">
                <span className="overview-footer-label Poppins-Regular">New This Month</span>
                <span className="overview-footer-value Baloo2-Bold"> {newThisMonth}</span>
              </div>
            </div>
          </div>

          {/* -------- Visit Requests Status -------- */}
          <div className="overview-chart-card">
            <div className="overview-chart-header">
              <h4 className="Baloo2-Bold">Visit Requests Status</h4>
              <div className="dropdown-container">
                <button
                  className={`overview-period-selector ${visitsDropdown ? 'active' : ''}`}
                  onClick={() => setVisitsDropdown(!visitsDropdown)}
                >
                  <span className="Poppins-Medium">{visitsPeriod}</span>
                  <ChevronDown size={14} className={`chevron ${visitsDropdown ? 'rotate' : ''}`} />
                </button>
                {visitsDropdown && (
                  <div className="dropdown-menu">
                    {periods.map((p) => (
                      <div
                        key={p}
                        className={`dropdown-item Poppins-Medium ${visitsPeriod === p ? 'selected' : ''}`}
                        onClick={() => { setVisitsPeriod(p); setVisitsDropdown(false); }}
                      >
                        {p}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="overview-chart-legend">
              <span className="legend-item"><span className="legend-dot legend-green" />Accepted</span>
              <span className="legend-item"><span className="legend-dot legend-red" />Rejected</span>
            </div>

            <div className="overview-chart-body">
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={visitRequestsData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }} barGap={4}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#eef0f4" vertical={false} />
                  <XAxis dataKey="date" stroke="#9a9a9a" tick={{ fontSize: 11, fontFamily: 'Poppins-Regular' }} axisLine={false} tickLine={false} />
                  <YAxis stroke="#9a9a9a" tick={{ fontSize: 11, fontFamily: 'Poppins-Regular' }} axisLine={false} tickLine={false} />
                  <Tooltip contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0', fontFamily: 'Poppins-Regular' }} />
                  <Bar dataKey="accepted" fill="#48bb78" radius={[4, 4, 0, 0]} barSize={12} />
                  <Bar dataKey="rejected" fill="#fc8181" radius={[4, 4, 0, 0]} barSize={12} />
                </BarChart>
              </ResponsiveContainer>
            </div>

            <div className="overview-chart-footer">
              <div className="overview-footer-item">
                <span className="overview-footer-label Poppins-Regular">Accepted Visits</span>
                <span className="overview-footer-value Baloo2-Bold value-green">{acceptedVisits}</span>
              </div>
              <div className="overview-footer-item">
                <span className="overview-footer-label Poppins-Regular">Rejected Visits</span>
                <span className="overview-footer-value Baloo2-Bold value-red">{rejectedVisits}</span>
              </div>
            </div>
          </div>

          {/* -------- KYC Requests Status -------- */}
          <div className="overview-chart-card">
            <div className="overview-chart-header">
              <h4 className="Baloo2-Bold">KYC Requests Status</h4>
              <div className="dropdown-container">
                <button
                  className={`overview-period-selector ${kycDropdown ? 'active' : ''}`}
                  onClick={() => setKycDropdown(!kycDropdown)}
                >
                  <span className="Poppins-Medium">{kycPeriod}</span>
                  <ChevronDown size={14} className={`chevron ${kycDropdown ? 'rotate' : ''}`} />
                </button>
                {kycDropdown && (
                  <div className="dropdown-menu">
                    {periods.map((p) => (
                      <div
                        key={p}
                        className={`dropdown-item Poppins-Medium ${kycPeriod === p ? 'selected' : ''}`}
                        onClick={() => { setKycPeriod(p); setKycDropdown(false); }}
                      >
                        {p}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="overview-donut-wrapper">
              <div className="overview-donut-chart">
                <ResponsiveContainer width="100%" height={160}>
                  <PieChart>
                    <Pie
                      data={kycData}
                      dataKey="value"
                      nameKey="name"
                      innerRadius={50}
                      outerRadius={70}
                      paddingAngle={2}
                      startAngle={90}
                      endAngle={-270}
                    >
                      {kycData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
                <div className="overview-donut-center">
                  <span className="donut-center-value Baloo2-Bold">{kycTotal}</span>
                  <span className="donut-center-label Poppins-Regular">Total</span>
                </div>
              </div>

              <div className="overview-donut-legend">
                {kycData.map((entry) => (
                  <div key={entry.name} className="donut-legend-item">
                    <span className="legend-dot" style={{ background: entry.color }} />
                    <span className="Poppins-Regular">{entry.name}</span>
                    <span className="Poppins-Medium donut-legend-value">
                      {/* {entry.value} ({Math.round((entry.value / kycTotal) * 100)}%) */}
                      {entry.value} (
                      {kycTotal ? Math.round((entry.value / kycTotal) * 100) : 0}%
                      )
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="overview-kyc-note">
              <CheckCircle2 size={18} className="kyc-note-icon" />
              <p className="Poppins-Regular">
                Keep your KYC verified to maintain trust and get more leads.
              </p>
            </div>
          </div>

        </div>
      </div>
    </SellerMasterLayout>
  );
};

export default SellerAnalytics;